<template>
    <div id="google-play-channel-detail">
        <AppBreadCrumb
            :paths="[{ title: $t('googlePlay.title') }]"
            :select="true"
            class="visitor-detail-bread-crumb"
        >
        </AppBreadCrumb>

        <div class="route-page-content breadcrumb-content" v-if="channel">
            <SidebarChild
                :items="menuItems"
                :selected-item="currentTab"
                :focusActive="true"
                @selected="(i) => (currentTab = i.key)"
            />
            <div class="page-content-wrapper">
                <div class="toolbar">
                    <div class="left">
                        <IconButton :on-click="() => $router.push('/integrations/google-play-reviews')">
                            <span class="material-icons"> chevron_left </span>
                        </IconButton>
                        <div class="icon-container">
                            <GooglePlayIcon />
                        </div>
                        <div class="name">{{ channel.name }}</div>
                    </div>
                    <div class="right">
                        <a-button type="danger" @click="deleteModal = true">
                            {{ $t("googlePlay.deleteChannel") }}
                        </a-button>
                    </div>
                </div>

                <div v-if="currentTab === 'detail'">
                    <UpdateDetail v-model="channel" @saved="refreshChannel" />
                </div>
                <div v-if="currentTab === 'visibility'">
                    <Visibility v-model="channel" @saved="refreshChannel" />
                </div>
                <div v-if="currentTab === 'apps'">
                    <AppList :channel="channel" />
                </div>
                <div v-if="currentTab === 'reviews'">
                    <ReviewList :channel="channel" />
                </div>
            </div>
        </div>
        <div class="loading" v-else>
            <a-spin />
        </div>

        <a-modal
            v-model="deleteModal"
            icon="exclamation-circle"
            :title="$t('googlePlay.title')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("googlePlay.deleteChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteGooglePlayChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import AppBreadCrumb from "../../../../../components/common/AppBreadCrumb.vue";
import SidebarChild from "../../../../../components/Sidebar/SidebarChild.vue";
import IconButton from "../../../Settings/components/IconButton.vue";
import GooglePlayIcon from "../../../Chatbot/pages/integrations/svg/GooglePlayIcon.vue";
import GooglePlayMenuTypes from "./GooglePlayMenuTypes";
import UpdateDetail from "./UpdateDetail.vue";
import Visibility from "./Visibility.vue";
import AppList from "./AppList.vue";
import ReviewList from "./ReviewList.vue";

export default Vue.extend({
    name: "GooglePlayChannelDetail",
    components: {
        AppBreadCrumb,
        SidebarChild,
        IconButton,
        GooglePlayIcon,
        UpdateDetail,
        Visibility,
        AppList,
        ReviewList,
    },
    data() {
        const path = (_.last(this.$route.path.split("/")) || "detail").toLowerCase().trim();
        const selected = Object.values(GooglePlayMenuTypes.Items(this)).find((x) => x.key === path);
        return {
            currentTab: selected ? selected.key : "detail",
            selectedChannelId: this.$route.params.id,
            deleteModal: false,
            channel: null,
            menuItems: GooglePlayMenuTypes.Items(this),
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "google-play-reviews"),
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            deleteChannel: "channel/deleteChannel",
        }),
        init() {
            this.channel = this.channels.find((x) => x._id === this.selectedChannelId);
            if (this.channel) {
                this.channel = _.cloneDeep(this.channel);
            }
        },
        deleteGooglePlayChannel() {
            this.deleteChannel(this.channel._id).then(() => {
                this.$router.push("/integrations/google-play-reviews");
            });
        },
        refreshChannel() {
            this.listChannels().then(() => {
                this.init();
            });
        },
    },
    mounted() {
        this.listChannels().then(() => {
            this.init();
        });
    },
    watch: {
        channels: {
            handler() {
                this.init();
            },
            deep: true,
        },
        currentTab(value) {
            const selected = Object.values(this.menuItems).find((x) => x.key === value);
            if (selected) {
                this.$router.push(`/integrations/google-play-reviews/${this.channel._id}/detail/${selected.key}`);
            }
        },
    },
});
</script>

<style scoped lang="scss">
#google-play-channel-detail {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 100%;
    height: 100%;

    .toolbar {
        padding: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 50px;
        border-bottom: 1px solid var(--color-border-default);

        .left {
            display: flex;
            align-items: center;
            gap: 5px;

            .name {
                font-size: 18px;
                font-weight: 700;
            }

            .icon-container {
                width: 30px;
                height: 30px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                overflow: hidden;
                position: relative;
                background: #fff;
                padding: 5px;

                svg {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
            gap: 5px;
        }
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    }
}
</style>
